<script>

export default {
  name : 'Input',
  props : {
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      required: true,
    },
    name: String,

    modelValue: String,

    error: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  methods : {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value );
    },
  }
}

</script>

<template>
  <fieldset class="mb-3">
    <label class="mt-1 rounded-md capitalize">{{ label }}</label>
    <div class="mt-1 rounded-md shadow-sm -space-y-px">
      <input
        :name="name"
        :type="type"
        :value="modelValue"
        class="border px-1 border-gray-300 rounded-lg shadow-sm block w-full resize-none focus:ring-0 sm:text-sm jack-description"
        @input="updateValue"
        required
      />
      <div v-if="error" v-text="error" class="mt-1 text-xs text-red-500"></div>
    </div>
  </fieldset>
</template>
